export default __webpack_public_path__ + "static/media/onlineTestIcon.9113bfc3.svg";